import { Inject, Injectable } from '@angular/core';
import { doc, docData, getFirestore } from '@angular/fire/firestore';
import { COMMONS_ENV, NetworkService, ObservableQueryService } from '@damofire/data-angular-commons';
import {
  Dto,
  ID_FIELD_OPTIONS,
  IndexedService,
  OFFLINE_WAREHOUSES_STORE,
  OUTLINES_STORE,
  Query,
  SearchResult,
  TEXTS_STORE,
  WAREHOUSES_STORE,
  WW_WAREHOUSES_COLLECTION,
} from '@damofire/data-commons';
import { firstValueFrom } from 'rxjs';
import { LockingIndexedService } from '../indexed/locking-indexed.service';
import { Warehouse } from './warehouse.dto';
import { WarehouseService } from './warehouse.service';

@Injectable()
export class IdbWarehouseService extends WarehouseService {
  constructor(
    private readonly idbService: IndexedService,
    private readonly lockingIdbService: LockingIndexedService,
    private readonly queryService: ObservableQueryService,
    @Inject(COMMONS_ENV) protected readonly environment: any,
    protected readonly networkService: NetworkService,
  ) {
    super(environment);
  }

  async get(id: string): Promise<Warehouse> {
    let warehouse: Warehouse;
    if (this.networkService.connected) {
      warehouse = await firstValueFrom(docData<Warehouse>(doc(getFirestore(), `${WW_WAREHOUSES_COLLECTION}/${id}`), ID_FIELD_OPTIONS));
    } else {
      warehouse = await this.idbService.getByKey<Warehouse>(WAREHOUSES_STORE, id);
    }

    return warehouse;
  }

  search(query: Query): Promise<SearchResult<Warehouse>> {
    return this.queryService.collection<Warehouse>(WW_WAREHOUSES_COLLECTION, query);
  }

  async reloadOutlines(): Promise<void> {
    this.outlines = await this.lockingIdbService.getAllFromIndex(this.divisionId, OUTLINES_STORE, 'division', this.divisionId);
  }

  async reloadLayoutTexts(): Promise<void> {
    this.texts = await this.lockingIdbService.getAllFromIndex(this.divisionId, TEXTS_STORE, 'division', this.divisionId);
  }

  async getOfflineWarehouses(): Promise<Dto<string>[]> {
    return this.idbService.getAll<Dto<string>>(OFFLINE_WAREHOUSES_STORE);
  }
}
